module.exports = __webpack_public_path__ + "static/img/23.472247a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/23.jpg
// module id = DPKT
// module chunks = 1